import { useEffect, useRef } from 'react';

const useUpdateEffect = (effect, dependencies) => {
  const isInitialRender = useRef(true);
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return undefined;
    }

    return effectRef.current();
    // Dependencies are supplied by the caller, matching React's built-in effects.
  }, dependencies); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useUpdateEffect;
